import type { PaperWithRole } from "@/types/paper";

/** Dismissal reasons that are a user's relevance judgement. MIRRORS
 * backend/src/paperchase_api/services/dismissal_signals.py
 * (JUDGMENT_DISMISSAL_REASONS) — keep the two in sync. Allowlist: system
 * reasons (`auto:*`, `cull:*`, `reset:*`, duplicate, not_found) are not
 * judgements. Stored as "<reason>" or "<reason>: <free text>". */
export const JUDGMENT_DISMISSAL_REASONS = [
  "scope",
  "methodology",
  "superseded",
  "other",
  "triage:dismissed",
] as const;

export function isJudgmentDismissal(reason: string | null | undefined): boolean {
  if (!reason) return false;
  return JUDGMENT_DISMISSAL_REASONS.some((r) => reason === r || reason.startsWith(`${r}: `));
}

/** "Reviewed" = the user made a decision about the paper (spec 2026-06-07,
 * amended 2026-09-27) — distinct from reading status, which only content
 * engagement moves. Backend twin: the `reviewed` count in api/papers.py. */
export function isReviewed(p: PaperWithRole): boolean {
  return (
    p.reading_status === "read" ||
    p.reading_status === "skimmed" ||
    (p.user_relevance_feedback ?? 0) !== 0 ||
    p.user_score_override != null ||
    isJudgmentDismissal(p.exclusion_reason) ||
    (p.notes ?? "").trim() !== "" ||
    (p.highlight_count ?? 0) > 0
  );
}
